export const SECTIONS = [
  {
    key: "site",
    label: "Site & Contact",
    fields: [
      { key: "tagline", label: "Tagline", type: "text" },
      { key: "phone1Display", label: "Phone 1 (display)", type: "text" },
      { key: "phone2Display", label: "Phone 2 (display)", type: "text" },
      { key: "whatsappNumber", label: "WhatsApp number (with country code, digits only)", type: "text" },
      { key: "whatsappMessage", label: "WhatsApp pre-filled message", type: "textarea" },
      { key: "emails", label: "Email addresses (one per line)", type: "stringList" },
      { key: "website", label: "Website", type: "text" },
      { key: "addressLines", label: "Address lines (one per line)", type: "stringList" },
      { key: "gstin", label: "GSTIN", type: "text" },
      { key: "udyam", label: "UDYAM", type: "text" },
      { key: "mapsQuery", label: "Google Maps location query", type: "text" },
    ],
  },
  {
    key: "images",
    label: "Images & Media",
    fields: [
      { key: "hero", label: "Hero slider images (URLs, one per line)", type: "stringList" },
      { key: "pmSurya", label: "PM Surya Ghar image URL", type: "text" },
      { key: "products", label: "Products image URL", type: "text" },
      { key: "residential", label: "Residential solution image URL", type: "text" },
      { key: "commercial", label: "Commercial solution image URL", type: "text" },
      { key: "industrial", label: "Industrial solution image URL", type: "text" },
      { key: "pump", label: "Solar pump image URL", type: "text" },
    ],
  },
  {
    key: "home",
    label: "Home Page",
    fields: [
      {
        key: "slides",
        label: "Hero Slides",
        type: "objectList",
        itemLabel: "Slide",
        fields: [
          { key: "image", label: "Image URL", type: "text" },
          { key: "eyebrow", label: "Eyebrow text", type: "text" },
          { key: "lines", label: "Headline lines (one per line)", type: "stringList" },
          { key: "sub", label: "Sub-heading", type: "textarea" },
        ],
      },
      {
        key: "highlights",
        label: "Hero Highlights (4 cards)",
        type: "objectList",
        itemLabel: "Highlight",
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
        ],
      },
      {
        key: "whyUs",
        label: "Why Choose Us (6 blocks)",
        type: "objectList",
        itemLabel: "Feature",
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
        ],
      },
      {
        key: "pmSubsidy",
        label: "PM Surya Ghar subsidy figures (home band)",
        type: "objectList",
        itemLabel: "Figure",
        fields: [
          { key: "v", label: "Value", type: "text" },
          { key: "l", label: "Label", type: "text" },
        ],
      },
      { key: "pmSteps", label: "PM Surya Ghar steps (home band, one per line)", type: "stringList" },
    ],
  },
  {
    key: "about",
    label: "About Page",
    fields: [
      { key: "paragraphs", label: "About paragraphs (one per line)", type: "stringList" },
      { key: "mission", label: "Mission", type: "textarea" },
      { key: "vision", label: "Vision", type: "textarea" },
      {
        key: "values",
        label: "Core Values",
        type: "objectList",
        itemLabel: "Value",
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  {
    key: "pmSurya",
    label: "PM Surya Ghar Page",
    fields: [
      { key: "intro", label: "Intro paragraph", type: "textarea" },
      { key: "stateNote", label: "State subsidy note", type: "textarea" },
      { key: "note", label: "Important note", type: "textarea" },
      {
        key: "subsidy",
        label: "Subsidy figures",
        type: "objectList",
        itemLabel: "Figure",
        fields: [
          { key: "v", label: "Value", type: "text" },
          { key: "l", label: "Label", type: "text" },
        ],
      },
      {
        key: "steps",
        label: "How it works — steps",
        type: "objectList",
        itemLabel: "Step",
        fields: [
          { key: "title", label: "Title", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  {
    key: "faqs",
    label: "FAQs",
    fields: [
      {
        key: "",
        label: "Questions & Answers",
        type: "objectList",
        itemLabel: "FAQ",
        rootList: true,
        fields: [
          { key: "q", label: "Question", type: "text" },
          { key: "a", label: "Answer", type: "textarea" },
        ],
      },
    ],
  },
  {
    key: "products",
    label: "Products",
    fields: [
      {
        key: "",
        label: "Product cards",
        type: "objectList",
        itemLabel: "Product",
        rootList: true,
        fields: [
          { key: "name", label: "Name", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  { key: "brands", label: "Brands", fields: [{
    key: "",
    label: "Brands",
    type: "objectList",
    itemLabel: "Brand",
    rootList: true,
    fields: [
      { key: "name", label: "Brand name", type: "text" },
      { key: "logo", label: "Logo image URL (or /assets/brands/... path)", type: "text" },
    ],
  }] },
  {
    key: "processSteps",
    label: "Process Steps",
    fields: [
      {
        key: "",
        label: "Steps",
        type: "objectList",
        itemLabel: "Step",
        rootList: true,
        fields: [
          { key: "n", label: "Number (e.g. 01)", type: "text" },
          { key: "title", label: "Title", type: "text" },
          { key: "desc", label: "Description", type: "textarea" },
        ],
      },
    ],
  },
  {
    key: "projects",
    label: "Projects",
    fields: [
      {
        key: "",
        label: "Project cards",
        type: "objectList",
        itemLabel: "Project",
        rootList: true,
        fields: [
          { key: "src", label: "Photo URL (or /assets/... path)", type: "text" },
          { key: "type", label: "Project type", type: "text" },
          { key: "location", label: "Location", type: "text" },
          { key: "scope", label: "Scope", type: "text" },
          { key: "detail", label: "Detail line", type: "text" },
        ],
      },
    ],
  },
  {
    key: "solutions",
    label: "Solution Pages",
    fields: [
      {
        key: "",
        label: "Solutions (7 pages)",
        type: "objectList",
        itemLabel: "Solution",
        rootList: true,
        fields: [
          { key: "slug", label: "Slug (URL, no spaces)", type: "text" },
          { key: "name", label: "Short name", type: "text" },
          { key: "title", label: "Page title", type: "text" },
          { key: "tagline", label: "Tagline", type: "text" },
          { key: "image", label: "Image URL", type: "text" },
          { key: "intro", label: "Intro paragraph", type: "textarea" },
          { key: "includes", label: "Includes list (one per line)", type: "stringList" },
          { key: "suitableTitle", label: "Suitable-for heading", type: "text" },
          { key: "suitable", label: "Suitable-for list (one per line)", type: "stringList" },
          { key: "cta", label: "CTA button text", type: "text" },
        ],
      },
    ],
  },
];
